(() => {
  class AspadzProductCardSwiper extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.retryTimer = null;
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.handleMotionPreferenceChange = this.handleMotionPreferenceChange.bind(this);
    }

    connectedCallback() {
      this.addMotionListener();
      this.init();
    }

    disconnectedCallback() {
      window.clearTimeout(this.retryTimer);
      this.removeMotionListener();

      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    addMotionListener() {
      if (this.motionQuery.addEventListener) {
        this.motionQuery.addEventListener('change', this.handleMotionPreferenceChange);
      } else {
        this.motionQuery.addListener(this.handleMotionPreferenceChange);
      }
    }

    removeMotionListener() {
      if (this.motionQuery.removeEventListener) {
        this.motionQuery.removeEventListener('change', this.handleMotionPreferenceChange);
      } else {
        this.motionQuery.removeListener(this.handleMotionPreferenceChange);
      }
    }

    init() {
      if (this.swiper) return;

      const slider = this.querySelector('[data-aspadz-product-card-swiper-slider]');
      const slides = this.querySelectorAll('.aspadz-product-card-swiper__slide');
      if (!slider || slides.length < 2) {
        this.handleMotionPreferenceChange();
        return;
      }

      if (typeof window.AspadzConceptCarousel === 'undefined') {
        this.retryTimer = window.setTimeout(() => this.init(), 120);
        return;
      }

      const delay = Number(this.dataset.autoplayDelay) || 5000;
      const pagination = this.querySelector('[data-aspadz-product-card-swiper-pagination]');
      this.style.setProperty('--aspadz-pcs-delay', `${delay}ms`);

      this.swiper = new window.AspadzConceptCarousel(slider, {
        allowTouchMove: true,
        autoplay: this.motionQuery.matches
          ? false
          : {
              delay,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            },
        centeredSlides: false,
        loop: false,
        navigation: {
          nextEl: this.querySelector('[data-aspadz-product-card-swiper-next]'),
          prevEl: this.querySelector('[data-aspadz-product-card-swiper-prev]'),
        },
        pagination: pagination
          ? {
              clickable: true,
              el: pagination,
              renderBullet(index, className) {
                return `
                  <button class="${className}" type="button" aria-label="Go to slide ${index + 1}">
                    <span class="aspadz-product-card-swiper__pagination-track">
                      <span class="aspadz-product-card-swiper__pagination-progress"></span>
                    </span>
                  </button>
                `;
              },
            }
          : undefined,
        slidesPerView: 'auto',
        spaceBetween: 15,
        speed: 650,
        watchOverflow: true,
        breakpoints: {
          750: {
            centeredSlides: false,
            spaceBetween: 20,
          },
        },
        on: {
          init: () => this.restartProgress(),
          slideChangeTransitionStart: () => this.restartProgress(),
          autoplayResume: () => this.restartProgress(),
        },
      });

      this.handleMotionPreferenceChange();
    }

    restartProgress() {
      this.classList.remove('is-progressing');

      window.requestAnimationFrame(() => {
        if (!this.motionQuery.matches) {
          this.classList.add('is-progressing');
        }
      });
    }

    handleMotionPreferenceChange() {
      const reduceMotion = this.motionQuery.matches;
      this.classList.toggle('aspadz-product-card-swiper--reduced-motion', reduceMotion);

      if (!this.swiper?.autoplay) {
        this.classList.toggle('is-progressing', !reduceMotion);
        return;
      }

      if (reduceMotion) {
        this.swiper.autoplay.stop();
        this.classList.remove('is-progressing');
      } else {
        this.swiper.autoplay.start();
        this.restartProgress();
      }
    }
  }

  if (!window.customElements.get('aspadz-product-card-swiper')) {
    window.customElements.define('aspadz-product-card-swiper', AspadzProductCardSwiper);
  }
})();
